var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CrudForm',{attrs:{"title":_vm.title,"labelSubmit":_vm.labelSubmit,"storeName":_vm.storeName,"submit":_vm.submit,"status":_vm.status,"canCancel":false,"canUpdateDelete":false,"next-link":"/admin/privacy","breadcrumbs":[
      {
        text: 'Configuración y politicas',
        disabled: false,
        href: '#'
      },
      {
        text: 'Modo de Verificación',
        disabled: false,
        href: '#'
      }
    ]}},[_c('ValidationObserver',{ref:"validator",scopedSlots:_vm._u([{key:"default",fn:function({}){return [_c('v-row',{attrs:{"no-gutters":"","justify":"center"}},[_c('v-col',{attrs:{"cols":"6"}},[_c('v-row',{attrs:{"no-gutters":"","justify":"center"}},[_c('v-col',{staticClass:"d-flex justify-center"},[_c('ValidationProvider',{ref:"name",attrs:{"rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_c('v-checkbox',{staticClass:"input-check-base mt-5",attrs:{"hide-details":"auto","on-icon":"$checkedIcon","off-icon":"$unCheckedIcon","label":"Automatico"},model:{value:(_vm.data.is_automatic),callback:function ($$v) {_vm.$set(_vm.data, "is_automatic", $$v)},expression:"data.is_automatic"}})]}}],null,true)})],1)],1)],1)],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }